/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accounts_NoteInputs */

const th_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การดูแลระบบผ่านปลั๊กอินผู้ดูแลของ Better Auth การสวมสิทธิ์ยังคงบันทึกตัวตนผู้ดูแลของคุณไว้ในเซสชัน`)
};

const en_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform administration, via Better Auth's admin plugin. Impersonation keeps your admin identity — the session records who is behind it.`)
};

const ja_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better Auth の管理プラグインによるプラットフォーム管理。代理表示中も管理者の身元はセッションに記録されます。`)
};

const zh_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过 Better Auth 的管理插件管理平台。切换身份不会抹去你的管理员身份——会话始终记录背后是谁。`)
};

const es_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración de la plataforma, mediante el complemento de administración de Better Auth. La suplantación conserva tu identidad de administrador: la sesión registra quién está detrás.`)
};

const pt_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administração da plataforma, pelo plugin de admin do Better Auth. A personificação mantém sua identidade de administrador — a sessão registra quem está por trás.`)
};

const id_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrasi platform lewat plugin admin Better Auth. Menyamar tidak menghapus identitas admin Anda — sesi tetap mencatat siapa di baliknya.`)
};

const fr_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration de la plateforme, via le module admin de Better Auth. L’usurpation conserve votre identité d’administrateur — la session enregistre qui est derrière.`)
};

const tl_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangangasiwa ng plataporma sa pamamagitan ng admin plugin ng Better Auth. Hindi nabubura ng pagpapanggap ang pagkakakilanlan mong admin — tandang-tanda ng sesyon kung sino ang nasa likod nito.`)
};

const vi_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản trị nền tảng qua plugin admin của Better Auth. Việc mạo danh không xoá danh tính quản trị của bạn — phiên vẫn ghi rõ ai đứng sau.`)
};

const ko_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better Auth의 관리자 플러그인을 통한 플랫폼 관리. 다른 사용자로 전환해도 관리자 신원은 사라지지 않으며, 세션이 누가 뒤에 있는지 기록합니다.`)
};

const de_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformverwaltung über das Admin-Plugin von Better Auth. Beim Identitätswechsel bleibt deine Admin-Identität erhalten — die Sitzung hält fest, wer dahintersteht.`)
};

const ru_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление платформой через admin-плагин Better Auth. Вход от чужого имени не стирает вашу личность администратора — сессия помнит, кто за этим стоит.`)
};

const tr_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform yönetimi Better Auth'un admin eklentisi üzerinden. Başkasının kimliğine bürünmek yönetici kimliğinizi silmez — oturum arkasında kimin olduğunu tutar.`)
};

const it_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amministrazione della piattaforma tramite il plugin admin di Better Auth. Impersonare qualcuno non cancella la tua identità di amministratore: la sessione registra chi c'è dietro.`)
};

const pl_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administracja platformy przez wtyczkę admin Better Auth. Wcielenie się w kogoś nie usuwa twojej tożsamości administratora — sesja pamięta, kto za tym stoi.`)
};

const uk_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адміністрування платформи через плагін admin у Better Auth. Вхід від чужого імені не стирає вашу особу адміністратора — сесія пам'ятає, хто за цим стоїть.`)
};

const hi_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेटफ़ॉर्म का प्रबंधन Better Auth के admin प्लगइन से होता है। किसी और के रूप में देखने पर आपकी व्यवस्थापक पहचान मिटती नहीं — सत्र याद रखता है कि पीछे कौन है।`)
};

const ar_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة المنصّة عبر إضافة admin في Better Auth. انتحال هوية شخص لا يمحو هويتك كمشرف — الجلسة تحتفظ بمن يقف خلفها.`)
};

const ms_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentadbiran platform melalui pemalam admin Better Auth. Menyamar tidak memadam identiti pentadbir anda — sesi tetap merekodkan siapa di sebaliknya.`)
};

const bn_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better Auth-এর admin প্লাগইনের মাধ্যমে প্ল্যাটফর্ম পরিচালনা। অন্যের পরিচয়ে দেখলে আপনার প্রশাসক পরিচয় মুছে যায় না — সেশন মনে রাখে পেছনে কে আছে।`)
};

const zh_tw2_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透過 Better Auth 的 admin 外掛管理平台。以他人身分檢視不會抹去你的管理者身分——工作階段仍記錄背後是誰。`)
};

const zh_hk2_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透過 Better Auth 的 admin 外掛程式管理平台。以他人身分檢視不會抹去你的管理者身分——工作階段仍記錄背後是誰。`)
};

const ur_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better Auth کے admin پلگ اِن کے ذریعے پلیٹ فارم کا انتظام۔ کسی اور کی حیثیت سے دیکھنے سے آپ کی منتظم شناخت نہیں مٹتی — سیشن یاد رکھتا ہے کہ پیچھے کون ہے۔`)
};

const fa_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدیریت پلتفرم از طریق افزونهٔ admin در Better Auth. دیدن به نام دیگری هویت مدیریتی شما را پاک نمی‌کند — نشست به یاد دارد چه کسی پشت آن است.`)
};

const sw_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uendeshaji wa jukwaa kupitia programu-jalizi ya admin ya Better Auth. Kuingia kwa jina la mtu mwingine hakufuti utambulisho wako wa msimamizi — kipindi kinakumbuka nani yuko nyuma yake.`)
};

const nl_accounts_note = /** @type {(inputs: Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformbeheer via de admin-plug-in van Better Auth. Iemand anders worden wist je beheerdersidentiteit niet — de sessie houdt bij wie erachter zit.`)
};

/**
* | output |
* | --- |
* | "Platform administration, via Better Auth's admin plugin. Impersonation keeps your admin identity — the session records who is behind it." |
*
* @param {Accounts_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const accounts_note = /** @type {((inputs?: Accounts_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accounts_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_accounts_note(inputs)
	if (locale === "ja") return ja_accounts_note(inputs)
	if (locale === "zh") return zh_accounts_note(inputs)
	if (locale === "es") return es_accounts_note(inputs)
	if (locale === "pt") return pt_accounts_note(inputs)
	if (locale === "id") return id_accounts_note(inputs)
	if (locale === "fr") return fr_accounts_note(inputs)
	if (locale === "tl") return tl_accounts_note(inputs)
	if (locale === "vi") return vi_accounts_note(inputs)
	if (locale === "ko") return ko_accounts_note(inputs)
	if (locale === "de") return de_accounts_note(inputs)
	if (locale === "ru") return ru_accounts_note(inputs)
	if (locale === "tr") return tr_accounts_note(inputs)
	if (locale === "it") return it_accounts_note(inputs)
	if (locale === "pl") return pl_accounts_note(inputs)
	if (locale === "uk") return uk_accounts_note(inputs)
	if (locale === "hi") return hi_accounts_note(inputs)
	if (locale === "ar") return ar_accounts_note(inputs)
	if (locale === "ms") return ms_accounts_note(inputs)
	if (locale === "bn") return bn_accounts_note(inputs)
	if (locale === "zh-TW") return zh_tw2_accounts_note(inputs)
	if (locale === "zh-HK") return zh_hk2_accounts_note(inputs)
	if (locale === "ur") return ur_accounts_note(inputs)
	if (locale === "fa") return fa_accounts_note(inputs)
	if (locale === "sw") return sw_accounts_note(inputs)
	if (locale === "nl") return nl_accounts_note(inputs)
	return en_accounts_note(inputs)
});